export default function useDataTransform(props, data) {
  return data?.[0]
}
